/* eslint-disable no-empty-character-class */
export const DRIVER_LICENSE_REGEX =
    /^([A-Za-z]\d{4})[-\s]?(\d{5})[-\s]?((?:\d{3})(?:(?:[0-2][0-9])|(?:3[0-1])))$/i;
export const LICENSE_CLASS_REGEX =
    /^(A(?:B(?:M[12]?)?|C(?:M[12]?)?|M[12]?)?|B(?:M[12]?)?|C(?:M[12]?)?|D(?:E|F(?:M[12]?)?|E?M[12]?|M[12]?)?|E(?:M[12]?)?|F(?:M[12]?)?|G[12]?(?:M[12]?)?|GM[12]?|M[12]?)$/i;
export const DRIVER_LICENSE_TRILLIUM_REGEX = /^\d{7}$/i;
export const RIN_REGEX = /^[0-9]{9}$/i;
export const LICENSE_PLATE_REGEX = /^[A-Za-z0-9 ]{2,8}$/i;
export const VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/i;
export const PHOTO_CARD_REGEX = /^(\d{3})[\s-]?([a-zA-Z]{2}\d{2})[\s-]?(\d{5})$/i;
export const PHOTO_CARD_DD_REGEX = /^[A-Z]{2}(?:\d){7}$/i;
export const HEALTH_CARD_RED_WHITE_NUMBER_REGEX =
    /^[1-9]\d{3}([\s-]?\d{3}[\s-]?){2}([a-zA-Z]{1,2})?$/i;
export const HEALTH_CARD_NUMBER_REGEX_OLD = /^[1-9]\d{3}([\s-]?\d{3}[\s-]?){2}[a-zA-Z]{1,2}$/i;
export const HEALTH_CARD_NUMBER_REGEX = /^(\d{4})(\d{3})(\d{3})([a-zA-Z]{2})$/;
export const HEALTH_CARD_NUMBER_REGEX_FORMATTED = /^\d{4}-\d{3}-\d{3}-[A-Z]{2}$/;
export const HEALTH_CARD_VERSION_CODE_REGEX = /^[A-Za-z]{1,2}$/;
export const HEALTH_CARD_DOCUMENT_CONTROL_NUMBER_REGEX = /^[A-Z]{2}(?:\d){7}$/i;
export const POSTAL_CODE_REGEX = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;
export const POSTAL_CODE_FORMAT = /([A-Za-z]\d[A-Za-z])\s?(\d[A-Za-z]\d)/;
export const POSTAL_CODE_ON_REGEX = /^[KLMNP]\d[A-Za-z]\s?\d[A-Za-z]\d$/;

// REGEX for PATTERNS
export const NAME_REGEX = /^[\p{L}](?:[-'., ]?[\p{L}]+)*[-'.,]?$/u;
export const FIRST_NAME_REGEX = /^([\p{L}]){2,}(((\s-\s)|([-'.,]?\s?))[\p{L}]+)*[-'.,]?\s*$/u;
export const MIDDLE_NAME_REGEX = NAME_REGEX;
export const LAST_NAME_REGEX = NAME_REGEX;
export const GENDER_PRONOUN_REGEX = /^[a-zA-Z]+([',/][a-zA-Z]+)*$/;
export const ADDRESS_1_REGEX = /^[a-zA-Z0-9\s/\-'.,]+$/;
export const ADDRESS_2_REGEX = /^[a-zA-Z0-9\s/\-'.,]+$/;
export const CITY_REGEX = /[a-zA-Z]+$/;
export const PHONE_NUMBER_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const PHONE_NUMBER_REGEX_WITH_CAPTURE_GROUPS =
    /^(\+\d{1,2}\s)?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/;
export const CELLPHONE_REGEX = /^(\d{3})(\d{3})(\d{4})$/;
export const UNIT_NUMBER_REGEX = /^[a-zA-Z0-9]+$/;
export const PLAN_NUMBER_REGEX = /^[a-zA-Z0-9]+$/;
export const LOT_NUMBER_REGEX = /^[a-zA-Z0-9]+$/;
export const CONCESSION_NUMBER_REGEX = /^[a-zA-Z0-9]+$/;
export const STREET_NUMBER_REGEX = /^[a-zA-Z0-9]+$/;
export const TOWNSHIP_REGEX = /^[a-zA-Z0-9\s/\-'.]+$/;
export const STREET_SUFFIX_REGEX = /[a-zA-Z]+$/;
export const PROVINCE_REGEX = /[a-zA-Z]+$/;
export const PHONE_EXTENSION_REGEX = /^\d{1,4}$/;
export const EMAIL_REGEX = /^[+\w0-9._-]+@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const EMAIL_REGEX_UNICODE =
    /^[\p{L}\p{M}0-9]+([._-][\p{L}\p{M}0-9]+)*@(?:[\p{L}0-9-]+\.)+[\p{L}]{2,}$/u;
export const DATE_OF_BIRTH_YEAR_REGEX = /^(19|20)\d{2}$/;
export const DATE_OF_BIRTH_MONTH_REGEX = /^(0?[1-9]|1[0-2])$/;
export const DATE_OF_BIRTH_DAY_REGEX = /^(0?[1-9]|[1-2][0-9]|3[0-1])$/;
export const PLATE_YEAR_REGEX = /^(19(0[1-9]|[1-9]\d)|[2-9]\d{3})$/;

export const PAYMENT_ERROR_CODE_REGEX = /020SE|020RE/i;

export const PERMIT_REGEX = /^(?!0{8})[A-Za-z0-9]\d{7}$/;
export const PLATE_REGEX = /^[A-Za-z0-9 ]{2,8}$/;
export const ODOMETER_REGEX = /^[0-9]{1,8}$/;
export const InsuranceCompany_REGEX = /^[A-Za-z0-9 \-éèêàâôîûç]{2,50}$/;
export const InsurancePolicyNumber_REGEX = /^[A-Za-z0-9]{2,16}$/;
export const OFFENCE_NUMBER_REGEX = /^[a-zA-Z0-9-]{1,23}$/;
export const SUSPENSION_NUMBER_REGEX = /^\d{7}$/;
export const OFFENCE_NUMBER_FORMAT_REGEX = /^(\w{4})(\w{3})(\w{2})(\w{0,}?)((\w{2})?)?$/;
export const ADDRESS_3_REGEX = /^(?=.*\S)[a-zA-Z0-9\s/\-'.,]+$/;

export const DRIVER_LICENSE_PATTERN: string = 'DXXXX-XXXXX-XXXXX';
export const HEALTH_CARD_PATTERN: string = 'XXXX-XXX-XXX-DD';
export const PHOTO_CARD_PATTERN: string = 'XXX-DDXX-XXXXX';
export const INVALID_CHARACTERS_REGEX = /\s/;
export const APP_IDENTIFICATION_REGEX = /\b(?:\d[\s-]?){15}\d\b/;
export const APP_IDENTIFICATION_REGEX_2 = /\b([A-Z0-9]){16}\b/;
export const APP_PERMIT_REGEX = /\b\d{7}\b/;
export const COMPANY_NAME_REGEX = /^[A-Za-z0-9 .'\-’"«»éèêàâôîûç]{2,50}$/;

export const US_STATE_REGEX = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
export const US_ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;
export const GENERAL_PURPOSE_POSTAL_CODE_REGEX = /^[A-Za-z0-9\s\-]{3,10}$/;
